export default __webpack_public_path__ + "static/media/mystery-nft.ff8702b2.jpg";